import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import './styles.css';
import { installerHorsLigne } from './hors-ligne';

const racine = document.getElementById('racine');
// Un montage silencieusement raté rendrait une page blanche sans cause visible.
if (!racine) throw new Error('#racine introuvable — index.html a été modifié');
createRoot(racine).render(<StrictMode><App /></StrictMode>);

/**
 * ⚠️ APRÈS LE MONTAGE, JAMAIS AVANT. Un enregistrement qui échoue ne doit pas
 * empêcher l'application de s'afficher : hors ligne est un CONFORT, le
 * registre est le métier.
 */
installerHorsLigne((etat) => {
  window.dispatchEvent(new CustomEvent('cadastral:hors-ligne', { detail: etat }));
});
